/* PillContainer alignment */
/** ******************* */
// Later on start and end will be added as well
var UitkPillContainerAlignmentMap = [['center', 'uitk-pill-container-align-center']];
var UitkPillContainerAlignments = new Map(UitkPillContainerAlignmentMap);

export { UitkPillContainerAlignments };
